var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28,
    fill: "none",
    className: "social-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok",
    clipPath: "url(#clip0_3601_1166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M24.3 11.83c-2.32 0-4.58-.72-6.47-2.07v9.42a8.57 8.57 0 1 1-7.4-8.5v4.75a3.93 3.93 0 1 0 2.76 3.75V.76h4.64a6.39 6.39 0 0 0 1.08 3.57 6.44 6.44 0 0 0 1.86 1.83 6.4 6.4 0 0 0 3.54 1.06v4.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3601_1166"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5.76h24v27H.5z"
  })))));
};
export default SvgTiktok;